export class EmailAlreadyExistsError extends Error {
  public constructor() {
    super()

    this.message = 'errors.emailAlreadyExists'
  }
}
